import { call, all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import notifications from '../../../redux/notifications/actions';
import { logger } from '../../../helpers/logger';
import { tableConfig } from '../../../settings';

const api = new Api('organizations/enterprise');

function* loadDataRequest({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          filters,
        }),
      );
    } else {
      actions.loadDataError();
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadDataRequest)]);
}
